<template>
    <div style="min-height: 100%;">
      <component :is="currentTab" ref='modalForm' ></component>
  </div>
</template>

<script>
  import BidProjectInfo from '@views/ebid/modules/BidProjectInfo'
  import RoomInfo from '@views/ebid/modules/RoomInfo'
  import DepositTemplate from "@views/ebid/modules/DepositTemplate";
  import AccessInfo from '@views/ebid/modules/AccessInfo.vue'
  import { httpAction,getAction } from '@/api/manage'

  export default {
    name: 'Info',
    components: {
      BidProjectInfo,
      RoomInfo,
      AccessInfo,
      DepositTemplate,
    },
    data() {
      return {
        description: '签章转换页面',
        currentTab: "BidProjectInfo",
        tenderProjectInfo: {},
      }
    },
    created() {
      this.tenderProjectInfo.id = this.$route.query.id;
      this.currentTab = this.$route.query.showTab;
      getAction("/ebid-ce/tmBidProject/queryById",{id:this.$route.query.id}).then(res=>{
        if(res.success) {
          this.tenderProjectInfo = res.result;
          this.showCurrentTab();
        }
      })
    },
    computed: {

    },
    methods: {
      showCurrentTab(){
        this.$nextTick(() => {
          this.$refs.modalForm.setBidProjectId(this.tenderProjectInfo.id, this.tenderProjectInfo.isRemoteEvaluation)
        })
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>